import { db } from "./initFirebase";
import { EVENTS_COLLECTION } from "../utils/consts";
const events = db.collection(EVENTS_COLLECTION);
export const fetchUpcomingEvents = async (limit = 5) => {
  const response = events
    .orderBy("start")
    .where("start", ">=", new Date().getTime())
    // .where("eventType", "==", "FEATURED")
    .where("status", "==", { active: "active" })
    .where("isDeleted", "==", false)
    .limit(limit);
  const { docs } = await response.get();
  return docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));
};



// WEBPACK FOOTER //
// ./src/firebase/events.js